import newestItemSection from './newestItemSection'

export default newestItemSection



// WEBPACK FOOTER //
// ./client/pages/home/newestItemSection/index.tsx